import React, { createContext,useContext,useState,useEffect } from 'react'
const Crypto= createContext();
    const CryptoContext = ({children}) => {

    
    const [currency, setcurrency] = useState('PKR');
    const [symbol, setsymbol] = useState('Rs');

    useEffect(() => {
      if(currency==="PKR") setsymbol('Rs')
    else if(currency==="USD") setsymbol("$")
    }, [currency])
    
  return (
    <Crypto.Provider value={{currency,setcurrency,symbol}}> {children} </Crypto.Provider>
  )
}

export default CryptoContext;

export const CryptoState= ()=>{
  return useContext(Crypto);
}

